import { createResourceStore } from './createResourceStore';
import { FILTER_CACHE_TTL } from '../shared/config/constants';

const useModelStore = createResourceStore({
  endpoint: '/admin/models',
  collectionKey: 'models',
  itemKey: 'model',
  cache: { ttl: FILTER_CACHE_TTL.models },
  methods: {
    fetch: 'fetchModels',
    create: 'createModel',
    update: 'updateModel',
    delete: 'deleteModel',
  },
});

export default useModelStore;
